module.exports = __webpack_public_path__ + "static/media/masthead-pilbara-news.47d4a990.svg";